// extracted by mini-css-extract-plugin
module.exports = {"heading":"SidebarContent_heading__naRXL","contents":"SidebarContent_contents__zalBL","sidebarContentWrapper":"SidebarContent_sidebarContentWrapper__s4OOH"};